import { useState } from 'react';

export default function CharitySection() {
  const [showVolunteerForm, setShowVolunteerForm] = useState(false);
  const [showDonationForm, setShowDonationForm] = useState(false);
  const [showMaterialForm, setShowMaterialForm] = useState(false);
  
  const [volunteerData, setVolunteerData] = useState({
    name: '',
    phone: '',
    email: '',
    type: '',
    experience: '',
    message: ''
  });

  const [donationData, setDonationData] = useState({
    name: '',
    phone: '',
    email: '',
    amount: '',
    method: '',
    message: ''
  });

  const [materialData, setMaterialData] = useState({
    name: '',
    phone: '',
    email: '',
    items: '',
    quantity: '',
    message: ''
  });

  const [volunteerStatus, setVolunteerStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [donationStatus, setDonationStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [materialStatus, setMaterialStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleVolunteerSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setVolunteerStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(volunteerData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4e156fqo628c0ftt4qg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setVolunteerStatus('success');
        setVolunteerData({ name: '', phone: '', email: '', type: '', experience: '', message: '' });
        setTimeout(() => {
          setShowVolunteerForm(false);
          setVolunteerStatus('idle');
        }, 2000);
      } else {
        setVolunteerStatus('error');
      }
    } catch (error) {
      setVolunteerStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDonationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setDonationStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(donationData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4e156fqo628c0ftt4r0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setDonationStatus('success');
        setDonationData({ name: '', phone: '', email: '', amount: '', method: '', message: '' });
        setTimeout(() => {
          setShowDonationForm(false);
          setDonationStatus('idle');
        }, 2000);
      } else {
        setDonationStatus('error');
      }
    } catch (error) {
      setDonationStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMaterialSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMaterialStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(materialData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4e156fqo628c0ftt4rg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setMaterialStatus('success');
        setMaterialData({ name: '', phone: '', email: '', items: '', quantity: '', message: '' });
        setTimeout(() => {
          setShowMaterialForm(false);
          setMaterialStatus('idle');
        }, 2000);
      } else {
        setMaterialStatus('error');
      }
    } catch (error) {
      setMaterialStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const charityProjects = [
    {
      title: '原住民孩童教育支持',
      icon: 'ri-book-open-line',
      image: 'https://public.readdy.ai/ai/img_res/ce95935c569e4f48cff6f05f2fb1638b.jpg',
      description: '透過中華原住民暨弱勢家庭孩童關懷協會，我們為原住民孩童提供免費的課後輔導與英語學習資源，幫助他們獲得平等的教育機會。',
      impact: '已幫助超過200位原住民孩童',
      color: 'from-green-500 to-emerald-600'
    },
    {
      title: '弱勢家庭學習補助',
      icon: 'ri-hand-heart-line',
      image: 'https://readdy.ai/api/search-image?query=Underprivileged%20children%20receiving%20educational%20support%20and%20tutoring%2C%20caring%20teachers%20helping%20students%2C%20warm%20classroom%20setting%20with%20simple%20clean%20background&width=400&height=300&seq=charity2&orientation=landscape',
      description: '針對經濟弱勢家庭的孩童，提供學費減免與教材補助，確保每個孩子都能接受優質的英語教育，不因家庭經濟狀況而失去學習機會。',
      impact: '每年補助150個家庭',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      title: '偏鄉教育推廣',
      icon: 'ri-map-pin-line',
      image: 'https://readdy.ai/api/search-image?query=Rural%20area%20education%20outreach%20program%2C%20teachers%20visiting%20remote%20schools%2C%20children%20learning%20English%20in%20countryside%20classroom%20with%20simple%20clean%20background&width=400&height=300&seq=charity3&orientation=landscape',
      description: '定期前往偏鄉地區進行英語教學服務，縮短城鄉教育差距。我們的教師志工團隊每月至少一次前往偏遠學校，帶給孩子們豐富的學習體驗。',
      impact: '服務10所偏鄉學校',
      color: 'from-purple-500 to-pink-600'
    },
    {
      title: '品格教育營隊',
      icon: 'ri-heart-3-line',
      image: 'https://readdy.ai/api/search-image?query=Character%20education%20camp%20for%20children%2C%20kids%20learning%20values%20and%20teamwork%2C%20outdoor%20activities%20with%20moral%20education%2C%20positive%20atmosphere%20with%20simple%20clean%20background&width=400&height=300&seq=charity4&orientation=landscape',
      description: '結合CMAP運動健康品格營隊，為弱勢孩童提供免費參加機會，透過營隊活動培養良好品格、團隊合作精神與健康生活習慣。',
      impact: '每年提供80個免費名額',
      color: 'from-orange-500 to-red-600'
    }
  ];

  const achievements = [
    { number: '500+', label: '受惠孩童', icon: 'ri-user-smile-line' },
    { number: '10', label: '合作學校', icon: 'ri-school-line' },
    { number: '50+', label: '志工夥伴', icon: 'ri-team-line' },
    { number: '8', label: '服務年資', icon: 'ri-time-line' }
  ];

  return (
    <>
      <section id="charity" className="py-20 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* 標題區 */}
          <div className="text-center mb-16">
            <a
              href="https://www.taiwanchild.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-4xl font-bold text-gray-800 mb-4 hover:text-orange-600 transition-colors cursor-pointer group"
            >
              <i className="ri-heart-3-fill text-red-500 mr-3"></i>
              中華原住民暨弱勢家庭孩童關懷協會
              <i className="ri-external-link-line text-2xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              教育是改變未來的力量。我們致力於為弱勢孩童提供平等的學習機會，
              讓每個孩子都能擁有追夢的權利，用愛心與專業陪伴他們成長。
            </p>
          </div>

          {/* 成果數據 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {achievements.map((item, index) => (
              <div key={index} className="bg-white rounded-lg p-6 text-center shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-3xl text-blue-600`}></i>
                </div>
                <div className="text-3xl font-bold text-gray-800 mb-2">{item.number}</div>
                <div className="text-gray-600">{item.label}</div>
              </div>
            ))}
          </div>

          {/* 公益項目 */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-gray-800 text-center mb-12">
              我們的公益項目
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {charityProjects.map((project, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="w-full h-56 object-cover object-top"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = `https://picsum.photos/seed/charity${index}/400/300.jpg`;
                    }}
                  />
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      <div className={`w-12 h-12 bg-gradient-to-br ${project.color} rounded-full flex items-center justify-center mr-4`}>
                        <i className={`${project.icon} text-white text-xl`}></i>
                      </div>
                      <h4 className="text-2xl font-bold text-gray-800">{project.title}</h4>
                    </div>
                    <p className="text-gray-600 mb-4 leading-relaxed">{project.description}</p>
                    <div className={`bg-gradient-to-r ${project.color} text-white px-4 py-2 rounded-lg inline-block`}>
                      <i className="ri-check-double-line mr-2"></i>
                      {project.impact}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 志工報名表單彈窗 */}
      {showVolunteerForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowVolunteerForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <h3 className="text-2xl font-bold text-gray-800 mb-6">志工報名</h3>

            <form id="volunteer-form" data-readdy-form onSubmit={handleVolunteerSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  value={volunteerData.name}
                  onChange={(e) => setVolunteerData({ ...volunteerData, name: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  聯絡電話 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={volunteerData.phone}
                  onChange={(e) => setVolunteerData({ ...volunteerData, phone: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電話"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電子郵件 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  value={volunteerData.email}
                  onChange={(e) => setVolunteerData({ ...volunteerData, email: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電子郵件"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  志工類型 <span className="text-red-500">*</span>
                </label>
                <select
                  name="type"
                  required
                  value={volunteerData.type}
                  onChange={(e) => setVolunteerData({ ...volunteerData, type: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇志工類型</option>
                  <option value="教學志工">教學志工</option>
                  <option value="教材編輯">教材編輯</option>
                  <option value="交通接送">交通接送</option>
                  <option value="活動記錄">活動記錄</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  相關經驗
                </label>
                <input
                  type="text"
                  name="experience"
                  value={volunteerData.experience}
                  onChange={(e) => setVolunteerData({ ...volunteerData, experience: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請簡述您的相關經驗"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  其他說明
                </label>
                <textarea
                  name="message"
                  value={volunteerData.message}
                  onChange={(e) => setVolunteerData({ ...volunteerData, message: e.target.value })}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                  placeholder="請告訴我們更多資訊（限500字）"
                ></textarea>
                <div className="text-xs text-gray-500 mt-1 text-right">
                  {volunteerData.message.length}/500
                </div>
              </div>

              {volunteerStatus === 'success' && (
                <div className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-check-line mr-2"></i>
                  報名成功！我們會盡快與您聯繫
                </div>
              )}

              {volunteerStatus === 'error' && (
                <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  提交失敗，請稍後再試
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '提交中...' : '提交報名'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* 愛心捐款表單彈窗 */}
      {showDonationForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowDonationForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <h3 className="text-2xl font-bold text-gray-800 mb-6">愛心捐款</h3>

            <form id="donation-form" data-readdy-form onSubmit={handleDonationSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  value={donationData.name}
                  onChange={(e) => setDonationData({ ...donationData, name: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  聯絡電話 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={donationData.phone}
                  onChange={(e) => setDonationData({ ...donationData, phone: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電話"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電子郵件 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  value={donationData.email}
                  onChange={(e) => setDonationData({ ...donationData, email: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電子郵件"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  捐款金額 <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="amount"
                  required
                  min="1"
                  value={donationData.amount}
                  onChange={(e) => setDonationData({ ...donationData, amount: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入捐款金額"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  捐款方式 <span className="text-red-500">*</span>
                </label>
                <select
                  name="method"
                  required
                  value={donationData.method}
                  onChange={(e) => setDonationData({ ...donationData, method: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇捐款方式</option>
                  <option value="信用卡">信用卡</option>
                  <option value="銀行轉帳">銀行轉帳</option>
                  <option value="ATM轉帳">ATM轉帳</option>
                  <option value="郵政劃撥">郵政劃撥</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  備註說明
                </label>
                <textarea
                  name="message"
                  value={donationData.message}
                  onChange={(e) => setDonationData({ ...donationData, message: e.target.value })}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                  placeholder="其他說明（限500字）"
                ></textarea>
                <div className="text-xs text-gray-500 mt-1 text-right">
                  {donationData.message.length}/500
                </div>
              </div>

              {donationStatus === 'success' && (
                <div className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-check-line mr-2"></i>
                  提交成功！我們會盡快與您聯繫
                </div>
              )}

              {donationStatus === 'error' && (
                <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  提交失敗，請稍後再試
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '提交中...' : '提交捐款'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* 教材捐贈表單彈窗 */}
      {showMaterialForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowMaterialForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <h3 className="text-2xl font-bold text-gray-800 mb-6">捐贈教材</h3>

            <form id="material-form" data-readdy-form onSubmit={handleMaterialSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  value={materialData.name}
                  onChange={(e) => setMaterialData({ ...materialData, name: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  聯絡電話 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  value={materialData.phone}
                  onChange={(e) => setMaterialData({ ...materialData, phone: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電話"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  電子郵件 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  value={materialData.email}
                  onChange={(e) => setMaterialData({ ...materialData, email: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請輸入您的電子郵件"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  捐贈物品 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="items"
                  required
                  value={materialData.items}
                  onChange={(e) => setMaterialData({ ...materialData, items: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="例如：教科書、文具、電腦設備等"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  數量/狀況
                </label>
                <input
                  type="text"
                  name="quantity"
                  value={materialData.quantity}
                  onChange={(e) => setMaterialData({ ...materialData, quantity: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="請描述物品數量及狀況"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  其他說明
                </label>
                <textarea
                  name="message"
                  value={materialData.message}
                  onChange={(e) => setMaterialData({ ...materialData, message: e.target.value })}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                  placeholder="其他說明（限500字）"
                ></textarea>
                <div className="text-xs text-gray-500 mt-1 text-right">
                  {materialData.message.length}/500
                </div>
              </div>

              {materialStatus === 'success' && (
                <div className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-check-line mr-2"></i>
                  提交成功！我們會盡快與您聯繫
                </div>
              )}

              {materialStatus === 'error' && (
                <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  提交失敗，請稍後再試
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '提交中...' : '提交捐贈'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
